import React, { ReactNode, useState, useEffect } from "react";
import Header from "../header/Header";

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  // Increment this key whenever the active workspace changes.
  // Applying it to the page content div forces React to fully unmount
  // and remount all page content, re-running every useEffect data fetch
  // so pages always show data for the current workspace.
  const [workspaceKey, setWorkspaceKey] = useState(0);

  useEffect(() => {
    const handleWorkspaceChanged = () => setWorkspaceKey((k) => k + 1);
    window.addEventListener("workspace-changed", handleWorkspaceChanged);
    return () => window.removeEventListener("workspace-changed", handleWorkspaceChanged);
  }, []);

  return (
    <div className="main-layout w-full min-h-screen">
      <Header />
      <main className="flex-grow bg-background/50 w-full main-content-container">
        <div key={workspaceKey} className="w-full h-full">{children}</div>
      </main>
    </div>
  );
};

export default MainLayout;
